import React from 'react';
// import PointLoginLogo from './../../../resources/RTCC/point_club_logo.jpg'
export const Image = (props) => {
    return(
        <img 
            src={props.image} 
            style={props.style}
            />
    );
}
// LoginImage.propTypes = {
//     width:PropTypes.any,
//     height:PropTypes.any,
// };